import { render, staticRenderFns } from "./JSONEditor.vue?vue&type=template&id=06f4f6cd&"
import script from "./JSONEditor.vue?vue&type=script&lang=js&"
export * from "./JSONEditor.vue?vue&type=script&lang=js&"
import style0 from "./JSONEditor.vue?vue&type=style&index=0&id=06f4f6cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports